import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Achievements from "./components/Achievements";
import Projects from "./components/Projects";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BlogPost from "./components/BlogPost";
import { Toaster } from "./components/ui/toaster";
import { Analytics } from '@vercel/analytics/react';
import { HelmetProvider } from 'react-helmet-async';
import SEO from "./components/SEO";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout wrapper component with proper spacing
const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="pt-15"> {/* Add padding for fixed header */}
        {children}
      </div>
      <Footer />
    </>
  );
};

// Home page - Full portfolio experience
const Home = () => {
  return (
    <>
     <SEO 
        title="Home"
        description="Gokul Krishnan Koyattassery (CodingSeagull) - Full Stack Developer specializing in Web Development, Mobile App Development, React, React Native, Next.js, Node.js, Python. Available for freelance projects in India and Saudi Arabia."
        keywords="Gokul Krishnan Koyattassery, CodingSeagull, Freelance Developer, Full Stack Developer India, Web Development, Mobile App Development, React Developer, React Native Developer"
        canonicalUrl="/"
      />
      <Header />
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Achievements />
      <Projects />
      <Blog />
      <Contact />
      <Footer />
    </>
  );
};

// Individual section pages for SEO
const ExperiencePage = () => {
  return (
    <Layout>
      <SEO 
        title="Experience"
        description="Professional experience of Gokul Krishnan Koyattassery -  Full Stack Developer. Expertise in React, React Native, Next.js, Node.js, Python, web development and mobile app development projects."
        keywords="Gokul Krishnan work experience, freelance developer experience, full stack developer portfolio, React projects, mobile app projects"
        canonicalUrl="/experience"
      />
      <div className="py-12">
        <Experience />
      </div>
    </Layout>
  );
};

const AchievementsPage = () => {
  return (
    <Layout>
      <SEO 
        title="Achievements & Awards"
        description="Professional achievements and awards of Gokul Krishnan Koyattassery (CodingSeagull). Recognition in web development, mobile app development, and freelance projects completed for clients worldwide."
        keywords="developer achievements, coding awards, freelance developer success, web development portfolio, mobile app development achievements, CodingSeagull awards, Gokul Krishnan achievements"
        canonicalUrl="/achievements"
      />
      <div className="py-12">
        <Achievements />
      </div>
    </Layout>
  );
};

const ProjectsPage = () => {
  return (
    <Layout>
       <SEO 
        title="Projects"
        description="Web development and mobile app development projects by Gokul Krishnan Koyattassery. React, React Native, Next.js, Node.js projects for clients in India and Saudi Arabia."
        keywords="web development projects, mobile app projects, React projects, React Native apps, freelance portfolio, CodingSeagull projects"
        canonicalUrl="/projects"
      />
      <div className="py-12">
        <Projects />
      </div>
    </Layout>
  );
};

const BlogPage = () => {
  return (
    <Layout>
      <SEO 
        title="Blog"
        description="Technical blog by Gokul Krishnan Koyattassery covering web development, mobile app development, React, React Native, Node.js, Python tutorials and insights."
        keywords="web development blog, React tutorials, React Native tutorials, coding blog, programming tutorials, CodingSeagull blog"
        canonicalUrl="/blog"
      />
      <div className="py-12">
        <Blog />
      </div>
    </Layout>
  );
};

const ContactPage = () => {
  return (
    <Layout>
      <SEO 
        title="Contact"
        description="Contact Gokul Krishnan Koyattassery for freelance web development and mobile app development projects. Available for React, React Native, Next.js, Node.js projects in India and Saudi Arabia."
        keywords="hire freelance developer, freelance web developer India, mobile app developer Saudi Arabia, React developer for hire, contact CodingSeagull"
        canonicalUrl="/contact"
      />
      <div className="py-12">
        <Contact />
      </div>
    </Layout>
  );
};

const BlogPostPage = () => {
  return (
    <Layout>
      <div>
        <BlogPost />
      </div>
    </Layout>
  );
};

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<ExperiencePage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
    </HelmetProvider>
  );
}

export default App;